<template>
  <div>
    <form>
      <p class="t-mb-4 t-text-3xl t-font-semibold">{{ location.name }}</p>

      <div class="location-form-field lg:t-w-1/2">
        <label for="customer-code">Customer Code</label>
        <input v-model="form.customerCode" id="customer-code" type="text" />
      </div>

      <div class="location-form-option">
        <input
          v-model="form.locationOptions"
          id="pickup"
          name="location-option"
          type="checkbox"
          value="pickup"
        />
        <div>
          <label for="pickup">Pickup</label>
          <p class="t-text-sm t-text-gray-800">
            Use this location for pickups
          </p>
        </div>
      </div>

      <div class="location-form-option">
        <input
          v-model="form.locationOptions"
          id="delivery"
          name="location-option"
          type="checkbox"
          value="delivery"
        />
        <div>
          <label for="delivery">Delivery</label>
          <p class="t-text-sm t-text-gray-800">
            Use this location for deliveries
          </p>
        </div>
      </div>
    </form>
    <div class="t-my-4 t-border-t-2 t-border-gray-800"></div>
    <section>
      <div class="location-form-field">
        <label>
          Address
        </label>
        <p>
          {{
            `${location.address.data.street_number} ${
              location.address.data.street_name
            }, ${location.address.data.suburb}, ${location.address.data.city} ${
              location.address.data.post_code
                ? location.address.data.post_code
                : ""
            }`
          }}
        </p>
      </div>

      <div class="t-grid t-grid-rows-1 t-grid-cols-2">
        <section>
          <p class="t-text-xl t-font-medium">Contacts</p>

          <div class="location-form-field">
            <label>Inward Goods Contact Person</label>
            <p>
              {{ location.contact_name || "Not Provided" }}
            </p>
          </div>

          <div class="location-form-field">
            <label>
              Inward Goods Email Address
            </label>
            <p>
              {{ location.email || "Not Provided" }}
            </p>
          </div>

          <div class="location-form-field">
            <label>Inward Goods Phone Number</label>
            <p>{{ location.phone || "Not Provided" }}</p>
          </div>

          <div
            v-if="
              location.receive_email ||
                location.receive_booking_email ||
                location.receive_booking_email
            "
            class="t-space-y-2"
          >
            <p class="t-text-xl t-font-medium">Notifications</p>

            <div class="t-flex t-flex-row">
              <p class="t-mr-4">Email&nbsp;&nbsp;&nbsp;</p>
              <div class="t-flex t-flex-col">
                <span v-if="location.receive_email">
                  <input
                    id="email-trucks"
                    :checked="location.receive_email"
                    :disabled="true"
                    name="email-trucks"
                    type="checkbox"
                    class="t-mt-1 t-h-4 t-w-4 t-text-indigo-600 t-border-gray-300 t-rounded"
                  />
                  <label
                    for="email-trucks"
                    class="t-font-medium t-text-gray-800 t-mb-0"
                    >Trucks Approaching Area</label
                  >
                </span>

                <span v-if="location.receive_booking_email">
                  <input
                    id="email-bookings"
                    :checked="location.receive_booking_email"
                    :disabled="true"
                    name="email-bookings"
                    type="checkbox"
                    class="t-mt-1 t-h-4 t-w-4 t-text-indigo-600 t-border-gray-300 t-rounded"
                    value="receiveBookingEmail"
                  />
                  <label
                    for="email-bookings"
                    class="t-font-medium t-text-gray-800 t-mb-0"
                    >Booking Updates</label
                  >
                </span>
              </div>
            </div>

            <div class="t-flex t-flex-row">
              <p class="t-mr-4">SMS&nbsp;&nbsp;&nbsp;&nbsp;</p>
              <div class="t-flex t-flex-col">
                <span v-if="location.receive_sms">
                  <input
                    id="sms-trucks"
                    :checked="location.receive_sms"
                    :disabled="true"
                    name="email-trucks"
                    type="checkbox"
                    class="t-mt-1 t-h-4 t-w-4 t-text-indigo-600 t-border-gray-300 t-rounded"
                  />
                  <label
                    for="sms-trucks"
                    class="t-font-medium t-text-gray-800 t-mb-0"
                    >Trucks Approaching Area</label
                  >
                </span>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="t-mb-4">
            <p
              v-if="location.has_forklift || location.depot"
              class="t-text-xl t-font-medium"
            >
              Location Features
            </p>

            <div v-if="location.has_forklift" class="location-form-option">
              <div>
                <label>Forklift</label>
                <p class="t-text-sm t-text-gray-800">
                  This location has a forklift
                </p>
              </div>
            </div>

            <div v-if="location.depot" class="location-form-option">
              <div v-if="location.depot">
                <label>Depot</label>
                <p class="t-text-sm t-text-gray-800">
                  This location is a Freighthub depot
                </p>
              </div>
            </div>
          </div>

          <div v-if="location.instructions" class="t-mb-4">
            <p class="t-text-xl t-font-semibold">Special Instructions</p>
            <p>{{ location.instructions }}</p>
          </div>

          <div>
            <h3
              class="t-font-medium t-text-gray-900 t-mb-0"
              style="font-size: 24px; line-height: 36px;"
            >
              Business Hours
            </h3>
            <div
              v-for="(businessHoursObject, dayIndex) in location.openingHours
                .data"
              :key="dayIndex"
              class="t-flex t-justify-between"
            >
              <span class="t-mb-1 t-font-semibold">
                {{ DAYS_IN_WEEK[dayIndex] }}
              </span>

              <span>
                {{ businessHoursObject.opening_hour }} -
                {{ businessHoursObject.closing_hour }}
              </span>
            </div>
          </div>
        </section>
      </div>
    </section>
    <!-- Buttons -->
    <div
      class="t-flex t-flex-row-reverse t-mt-4 t-border-t t-border-gray-800 t-pt-4"
    >
      <button
        @click.prevent="onSubmitForm"
        :disabled="isSaving"
        class="t-text-lg t-font-medium t-bg-blue-500 t-text-white t-py-2 t-px-4 t-rounded-lg"
      >
        <i v-if="isSaving" class="fa fa-spinner fa-spin" />
        Save
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditOtherBusinessOwnedLocationForm",
  description: "",
  props: {
    location: {
      type: Object
    },
    locationType: {
      type: String
    }
  },
  data() {
    return {
      isSaving: false,
      form: {
        customerCode: "",
        locationOptions: []
      }
    };
  },
  created() {
    this.DAYS_IN_WEEK = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday"
    ];
    this.form.customerCode = this.location.customer_code;
    this.form.locationOptions = [
      ...(this.location.pickup ? ["pickup"] : []),
      ...(this.location.delivery ? ["delivery"] : [])
    ];
  },
  methods: {
    onSubmitForm() {
      this.isSaving = true;

      let data = {
        customer_code: this.form.customerCode,
        pickup: !!this.form.locationOptions.includes("pickup"),
        delivery: !!this.form.locationOptions.includes("delivery")
      };

      axios
        .patch(`/settings/locations/test/${this.location.id}`, data)
        .then(() => {
          this.$swal({
            title: "Added Location!",
            type: "success",
            confirmButtonText: "Okay"
          });

          let payload = {
            id: this.location.id,
            type: this.locationType
          };
          this.$emit("formSubmitted");
          this.$parent.$emit("submitted", payload);
          this.isSaving = false;
        });
    }
  }
};
</script>

<style scoped></style>
